'use client';

import React from 'react';
import { Grid, GridItem } from '@skin-seoul/design-system';
import ProductCard from '@/components/products/ProductCard';
const TopRankedProductGridSkeleton = () => {
  return <Grid templateColumns={{
    base: 'repeat(1, 1fr)',
    tablet: 'repeat(2, 1fr)',
    desktop: 'repeat(3, 1fr)'
  }} gap={{
    base: 3,
    tablet: 4
  }} width="100%" data-sentry-element="Grid" data-sentry-component="TopRankedProductGridSkeleton" data-sentry-source-file="TopRankedProductGridSkeleton.tsx">
      {[1, 2, 3, 4, 5, 6, 7, 8, 9].map((item, index) => <GridItem key={item} display={{
      base: index >= 5 ? 'none' : 'block',
      tablet: index >= 6 ? 'none' : 'block',
      desktop: index >= 9 ? 'none' : 'block'
    }}>
          <ProductCard.Skeleton orientation="horizontal" width="100%" />
        </GridItem>)}
    </Grid>;
};
export default TopRankedProductGridSkeleton;